export default {
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    vatWithPercent: 'VAT ({percent}%)',
    vatWithoutPercent: 'VAT',
    whtWithPercent: 'WHT ({percent}%)',
    whtWithoutPercent: 'WHT',
    total: 'Total',
    year: 'Year',
    years: 'year(s)',
    price: 'Price',
    duration: 'Duration',
    payment_plan: 'Payment Plan',
    loading: 'Loading',
    action: 'Action',
    filter_search: 'Filter Search',
    search: 'Search',
    from: 'From',
    to: 'To',
    reset: 'Reset',
    type: 'Type',
    hello: 'Hello',
    processing: 'Processing',
    choose_file: 'Choose a file...',
    drop_file: 'Drop file here...',
    warning: 'Warning',
    no_more_result: 'No more results',
    empty_data: 'There is no data',
    yes: 'Yes',
    no: 'No',
    for: 'for',
    all: 'All',
    browse: 'Browse',
    no_records: 'There are no records to show',
    upgrade_fee: 'Upgrade Fee',
    duration_type: {
        MONTH: 'Month(s)',
        YEAR: 'Year(s)',
    },
    duration_short_type: {
        MONTH: 'mo',
        YEAR: 'yr',
    },
    mo: 'mo',
    none: 'None',
    update_server_name: 'Update Server Name',
    package: 'Package',
    time_extension: 'Time Extension',
    time_extension_hint:
        'Your current service has less than 30 days, please choose time extension at least 1 month in order to upgrade',
    upgrade_fee_to: 'Upgrade Fee (to {date})',
    extend: 'Extend',
    current: 'Current',
    detail: 'Detail',
    details: 'Details',
    timezone: 'Timezone',
    tos: 'Terms of service',
    retry: 'Retry',
    username: 'Username',
    on: 'On',
    off: 'Off',
    note: 'Note',
    new: 'New',
    save: 'Save',
    domain: 'Domain | Domains',
    of: 'of',
    used: 'used',
    days: 'day(s)',
    click_here: 'click here',
    date: 'Date',
    selected: 'Selected',
    select_minute: 'Select minute',
    select_hour: 'Select hour',
    select_day: 'Select day',
    select_cycle: 'Select cycle',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    rename: 'Rename',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    custom: 'Custom',
    results: 'Results',
    enter_script: 'Enter script',
    copy: 'copy | copies',
    confirm: 'Confirm',
    unknown: 'Unknown',
    region: 'Region',
    month_pluralization: 'month | months',
    description: 'Description',
    amount: 'Amount',
    or: 'Or',
    company_name: 'Company name',
    customer: 'Customer',
    address: 'Address',
    description_of_services: 'Description of Services',
    quantity: 'Quantity',
    unit_price: 'Unit price',
    mail: 'Mail',
    phone_number: 'Phone number',
    confirm_status: 'Your Confirm Status',
};
